import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

// get auth state slice from the full state
const useUserProfile = () => useSelector((state: RootState) => state?.auth?.user);

export default useUserProfile;
